module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "The Characters"
    }
  }, [_c('p', {
    staticClass: "head",
    attrs: {
      "id": "tc"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#R_tc"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('i', [_vm._v("The Characters")])])])]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_c('i', [_vm._v("The Fallen")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Lucifer:")]), _vm._v(" "), _c('i', [_vm._v("Satan,")]), _vm._v(" King of Perdition. Tempter; Adversary; Sovereign Ruler of the race of men, Earth, and the nether regions.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Charsoc:")]), _vm._v(" Dark Apostle. Chief High Priest of the Fallen; Governor of the Grand Wizards of the Black Court and the dreaded Warlock Kings of the West.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Marduk:")]), _vm._v(" Head of the Darkened Councils and Lucifer’s Chief of Staff.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Darsoc:")]), _vm._v(" Princeling of legion of Grey Magi.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Lord Astaroth:")]), _vm._v(" Michael’s ex-general. Lucifer’s commander-in-chief and Grand Duke of Perdition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Moloch:")]), _vm._v(" Satanic prince. ‘Butcher’ of Perdition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Dagon:")]), _vm._v(" Commander of the Black Horde.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Folcador")]), _vm._v(": Grand Duke of Hell.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Merodach:")]), _vm._v(" Satanic regent of the kingdom of Babylonia.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Gaap:")]), _vm._v(" King of the Western Region of Hell. Chief elder of the underlords.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Nisroc the Ancient:")]), _vm._v(" Keeper of Death and the Grave.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Nakan:")]), _vm._v(" Warlock King of the Necromancers of the East.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('b', [_vm._v("Dracul:")]), _vm._v(" Ruler of Warlock Kings of the West.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Sethunelah:")]), _vm._v(" Ancient leader of the Dark Grey Magi.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Huldah:")]), _vm._v(" Dark Overlord of the Shaman Kings.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Dagda:")]), _vm._v(" Newly crowned Ruler of the Necromancer Kings.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Failenn:")]), _vm._v(" Queen of the Demon Witches.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Balberith:")]), _vm._v(" Lucifer’s chief attendant.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Zadkiel:")]), _vm._v(" Lucifer’s aide. Banished to Tartarus, the Abyss.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Ramuel and Mulciber:")]), _vm._v(" Generals of the Black Horde.")]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_c('i', [_vm._v("Dread Councils of Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("The Dread Warlocks of Ishtar.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Archangels of Astaroth.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Thrones of Folcador.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Black Magi.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("The Necromancer Kings.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Demon Witches.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Hera and the Banshees of Valkyrie.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Shaman Kings.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("The Wort Seers of Diabolos.")])]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_c('i', [_vm._v("First Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Michael:")]), _vm._v(" Chief Prince of the Royal House of Yehovah. Commander-in-chief of First Heaven’s armies; President of the warring councils.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Gabriel:")]), _vm._v(" Chief Prince of the Royal House of Yehovah. Lord Chief Justice of angelic Revelators.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Yehovah:")]), _vm._v(" Ancient of Days.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Christos:")]), _vm._v(" Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Jether:")]), _vm._v(" Imperial warrior; Ruler of the twenty-four ancient monarchs of the First Heaven and High Council Chief Steward of Yehovah’s sacred mysteries.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('b', [_vm._v("Xacheriel:")]), _vm._v(" Ancient of Days, Curator of the sciences and universes; one of the twenty-four ancient kings under Jether’s governance.")])]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_c('i', [_vm._v("High Ruling Council of Angelic Elders")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Jether, Xacheriel.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Maheel, Lamaliel.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Issachar, Zebulon.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Jehosaphat, Methuselah.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Raphael:")]), _vm._v(" Lucifer’s ex-commander-in-chief. Michael’s leading general.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Ephaniah:")]), _vm._v(" Lucifer’s ex-manservant.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Uriel, Ariel")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Adam:")]), _vm._v(" First-born of the race of men.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Younglings:")]), _vm._v(" An ancient angelic race with the characteristics of eternal youth and a remarkable inquisitiveness, expressly designed as apprentices to assist the Ancient Ones in their custodianship of Yehovah’s countless new galaxies.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Obadiah, Dimnah.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Tirzah, Rakkon.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Otniel, Jatir.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Lamech, Kalleel.")])]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_c('i', [_vm._v("Earth: 2021")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Jotapa:")]), _vm._v(" (22), Princess of Jordan.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Nick De Vere:")]), _vm._v(" (29), youngest brother, De Vere dynasty. Archaeologist; dying of Aids.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Adrian De Vere:")]), _vm._v(" (40), middle brother, De Vere dynasty. Former prime minister of the United Kingdom; newly "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_vm._v("appointed President of the United States of Europe; Nobel Peace Prize nominee.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Jason De Vere:")]), _vm._v(" (44), eldest brother: De Vere dynasty. US media tycoon; owns a third of the Western world’s television and newspaper empires.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Julia St Cartier:")]), _vm._v(" (42), Jason De Vere’s ex-wife.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Lily De Vere:")]), _vm._v(" (15), Julia and Jason’s daughter. Crippled.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Lilian De Vere:")]), _vm._v(" (76), Nick, Adrian and Jason De Vere’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Lawrence St Cartier:")]), _vm._v(" (82), Jesuit priest; retired CIA; antiquities dealer. Julia St Cartier’s uncle.")]), _vm._v(" "), _c('p', {
    staticClass: "sub1"
  }, [_c('i', [_vm._v("Earth: "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" 28")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("The Nazarene:")]), _vm._v(" Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Aretas:")]), _vm._v(" King of Arabia/Petra.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Jotapa:")]), _vm._v(" Princess of Arabia.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Zahi:")]), _vm._v(" Crown Prince of Arabia.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Ayeshe:")]), _vm._v(" Aretas’ manservant.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("Duza:")]), _vm._v(" Zahi’s bearer.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb7a64e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310096153_The_Characters.vue
// module id = 69
// module chunks = 0